export const customNodes = ['clozeNode', 'fillInTheBlanksNode'];
